import { mapLinks } from '../../../../../../../utils';
import { firstColumnCategories, fourthColumnCategories, secondColumnCategories, thirdColumnCategories, } from './categoriesMobile';
export const getDesktopColumnCategories = (columnCategories) => ({
    columnTitle: columnCategories.columnTitle,
    links: mapLinks(columnCategories.links.slice(0, 7)),
});
export const firstColumnCategoriesDesktop = getDesktopColumnCategories(firstColumnCategories);
export const secondColumnCategoriesDesktop = getDesktopColumnCategories(secondColumnCategories);
export const thirdColumnCategoriesDesktop = getDesktopColumnCategories(thirdColumnCategories);
export const fourthColumnCategoriesDesktop = getDesktopColumnCategories(fourthColumnCategories);
//# sourceMappingURL=categories.js.map